
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";
import Certifications from "./Certifications";

function About() {
  return (
    <>
      <Particle />

      <Container fluid className="about-section">
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              md={7}
              style={{
                justifyContent: "center",
                paddingTop: "30px",
                paddingBottom: "50px",
              }}
            >
              <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                About <strong className="purple">Wilecurity</strong>
              </h1>

              <Aboutcard />
            </Col>

            <Col
              md={5}
              style={{ paddingTop: "120px", paddingBottom: "50px" }}
              className="about-img"
            >
              <img
                src={laptopImg}
                alt="Cybersecurity engineering and technical research"
                className="img-fluid"
              />
            </Col>
          </Row>

          <h1 className="project-heading">
            Technical <strong className="purple">Skills</strong>
          </h1>

          <Techstack />

          <Certifications />

          <h1 className="project-heading">
            <strong className="purple">Tools & Technologies</strong>
          </h1>

          <Toolstack />

          <Github />
        </Container>
      </Container>
    </>
  );
}

export default About;
